import { useState, useEffect, useContext } from "react";
import "./css/novoPedido.css";
import './css/home.css'
import Axios from "axios";
import { LoginContext } from '../context/LoginContext.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical, faXmark } from '@fortawesome/free-solid-svg-icons'; 
import { ConfirmModal } from '../geral.jsx'
import { MsgModal } from '../geral.jsx'
import Menu from "./Menu.jsx";
import Loading from "./Loadingg.jsx";
import Navbar from "./navbar.jsx";
import { getTable, joinTable } from "../service/tables-service.jsx";
import { cancelOrder, getOrderList, saveObsOrder } from "../service/group-service.jsx";
import { baseURL } from '../service/api.jsx';


export default function Home() {
  const [grupoPedido, setGrupoPedido] = useState([]);
  const [removeLoading, setRemoveLoading] = useState(false);
  const { idGrupoPedido, setIdGrupoPedido, setNomeGrupoPedido, 
         confirmModal, setConfirmModal, msgModal, setMsgModal, database } = useContext(LoginContext);
  const [verPedido, setVerPedido] = useState(false);
  const [listaProduto, setListaProduto] = useState(); 
  const [setCardUnirMesa] = useState(false); 
  const [table, setTable] = useState();
  const [textModal, setTextModal] = useState(); 
  const [functionModal, setFunctionModal] = useState(); 
  const [link, setLink] = useState();
  const [menuOpen, setMenuOpen] = useState(null);
  const [mesasOpen, setMesasOpen] = useState(null);
  const [mostrarObservacao, setMostrarObservacao] = useState(false);
  const [observacao, setObservacao] = useState("");


  

  function closeModal(action){
    if (action === 'msg') {
      setMsgModal(false);
    } else {
      setConfirmModal(false);
    }
  }

  function openModal(action, idGrupoPedido, nomeGrupoPedido, msg){
    if(action !== 'msg'){
      if(action === 'edit'){
        setTextModal('Deseja Editar o Pedido?');
        setFunctionModal(() => () => editarPedido(idGrupoPedido, nomeGrupoPedido)); 
        setLink('/editarPedido');     
      }else if(action === 'cancel'){      
        setTextModal('Deseja Cancelar o Pedido?');
        setFunctionModal(() => () => cancelarPedido(idGrupoPedido));
        setLink(''); 
      }
      setConfirmModal(true);
    }else if(action === 'msg'){         
      setTextModal(msg);      
      setMsgModal(true);      
      setCardUnirMesa(false);    
    }
  }

  const atualizarLista = async () => {
    try {
      const lista = await getOrderList(database); 
      setGrupoPedido(lista); 
      setRemoveLoading(true);
    } catch (error) {
      console.error("Erro ao atualizar lista:", error);
    }
  };


  useEffect(() => {
    atualizarLista();

    const interval = setInterval(() => {
      atualizarLista();
    }, 20000);

    return () => clearInterval(interval);
  }, []);

  function editarPedido(idGrupoPedido, nomeGrupoPedido) {        
    setIdGrupoPedido(idGrupoPedido); 
    setNomeGrupoPedido(nomeGrupoPedido);
    setConfirmModal(false);
  }

  async function cancelarPedido(idGrupoPedido) {    
    if (idGrupoPedido > 0) {
       await cancelOrder(database, idGrupoPedido);
        atualizarLista();      
    } else {
      openModal('msg', null, null, 'Pedido não encontrado.');      
    }
    setConfirmModal(false);
  }

  function listarProdutos(idGrupoPedido){
    if (idGrupoPedido > 0) { 
      setRemoveLoading(false);   
        Axios.post(`${baseURL}/orderGroup/orderGroupListProduct`, {
          idGrupoPedido: idGrupoPedido,
          database: database
        }).then((response) => {
          setListaProduto(response.data);                        
        })      
        atualizarLista();
      }
  }

  useEffect(() => {
    listarProdutos();
  }, [])
  
  function mostrarPedido(index, idGrupoPedido){
    const divCardVerPedido = document.getElementsByClassName('divCardVerPedido');
    const divCardListProduct = document.getElementsByClassName('divCardListProduct');
    const buttonVerPedido = document.getElementsByClassName('buttonVerPedido');

    for(let i = 0; i < divCardVerPedido.length; i++) {
      divCardVerPedido[i].classList.remove('mostrarPedido');
      divCardListProduct[i].classList.remove('divCardListProductMostrar');            
      buttonVerPedido[i].innerHTML = 'Ver Pedido';        
      setListaProduto('');
    }

    if (!verPedido && buttonVerPedido[index].innerHTML === 'Ver Pedido'){      
      divCardVerPedido[index].classList.add('mostrarPedido');
      divCardListProduct[index].classList.add('divCardListProductMostrar');          
      listarProdutos(idGrupoPedido); 
      buttonVerPedido[index].innerHTML = 'Fechar Pedido';  
      setVerPedido(true);         
    }else{      
      buttonVerPedido[index].innerHTML = 'Ver Pedido';
      setVerPedido(false);
    }  
    setRemoveLoading(true);        
  }

  function abrirMenu(idGrupoPedido){
    setMenuOpen(menuOpen === idGrupoPedido ? null : idGrupoPedido);
    setIdGrupoPedido(idGrupoPedido)    
  }

  function mostrarMesas(action, idGrupoPedido){
    setRemoveLoading(false);
    if (action == 'disponiveis'){
      setIdGrupoPedido(idGrupoPedido);
      setMesasOpen(true);
      setTable(getTable('disponiveis', null));
      setRemoveLoading(true);
    }else if(action == 'ocupadas'){
      setIdGrupoPedido(idGrupoPedido);
      setMesasOpen(true);      
      setTable(getTable('ocupadas', idGrupoPedido));
      setRemoveLoading(true);
    }    
  }

  useEffect(() => {
    async function fetchData() {
      const data = await getTable("disponiveis");
      setTable(data);
    }
    fetchData();
  }, []);

  function unirMesa(idMesa){  
    if (idGrupoPedido > 0) {      
        joinTable(idGrupoPedido, idMesa);
        atualizarLista();
        setMesasOpen(null);   
        setMenuOpen(null);   
    } else {      
      openModal('msg', null, null, 'Pedido não encontrado');
    }
    setTable(getTable('ocupadas', null));
    setRemoveLoading(true);
  }

  function adicionarObservacao(){
    setMostrarObservacao(true);
  }

  function fecharMenu(){
    setMenuOpen(null);
    setMostrarObservacao(false);
  }

  function salvarObservacao(observacao, idGrupoPedido){
    if (idGrupoPedido > 0) {      
      saveObsOrder(idGrupoPedido, observacao, database)
      atualizarLista();
      setMesasOpen(null);   
      setMenuOpen(null);   
      setMostrarObservacao(false);
    } else {      
      openModal('msg', null, null, 'Pedido não encontrado');
    }
  }
  
  return (
    <>
      <Navbar />
      <main className="lg:my-20 xl:my-20"> 
        <Menu />       
        <div className="pb-20">
          { mesasOpen === null ?
          <div>
            {grupoPedido && grupoPedido.map((value, index) => (                         
              <div key={value.idGrupoPedido} className={`cardContainer ${index !== 0 ? 'mb-8' : ''}`}>                              
                { menuOpen !== value.idGrupoPedido ? 
                  <div className='cardContent'>
                    <div className="cardPrincipal">
                      <div className="cardPrincipalTop">    
                        <p className="statusPedido">{value.idGrupoPedido} - {value.statusPedido}</p>                                                    
                        <button onClick={() => abrirMenu(value.idGrupoPedido)}>
                          <FontAwesomeIcon className="iconMenu" icon={faEllipsisVertical}  />
                        </button>
                      </div>                    
                      <p className="cardNomeGrupoPedido">{value.nomeGrupoPedido}</p>                                                      
                    </div>
                    <div className="cardInfo">                  
                      <p className=""> {value.horaPedido}</p>                    
                      {value.mesaAdicional !== value.nomeMesa ? 
                        <div className="mesaAdicional">
                          <p>{value.nomeMesa}</p>                        
                          <p>{value.mesaAdicional}</p>
                        </div>                  
                        : 
                        <p className="">{value.nomeMesa}</p>
                      }
                      <p className="">R$ {value.valorPedido.toFixed(2)}</p>
                    </div>                                           
                    <div className="cardButton">
                      {value.ativoBaixa === 'PAGO' && (
                        <button className="cardInfo">
                          Pedido Pago
                        </button>
                      )}

                      {value.ativoBaixa === 'PENDENTE' && (
                        <>
                          <button className="buttonCancelar" onClick={() => openModal('cancel', value.idGrupoPedido)}>
                            Cancelar
                          </button>                        
                          <button className="buttonEditar" onClick={() => openModal('edit', value.idGrupoPedido, value.nomeGrupoPedido)} >
                            Editar
                          </button>                        
                        </>
                      )}
                    </div>              
                    {!removeLoading ? 
                      <Loading />                 
                      : 
                      <div onClick={() => mostrarPedido(index, value.idGrupoPedido)} className='divCardVerPedido' >
                        <button className='buttonVerPedido' >Ver Pedido</button>                     
                        <div className= {`divCardListProduct`}  >
                          {listaProduto && listaProduto.map((value, index) => (                        
                            <div key={value.idProduto} className={`${index !== 0 ? 'cardListProduct' : 'cardListProduct'}`}>                                              
                              <p>{value.nomeProduto}</p>                                                                                                                                                                                               
                              <p>{value.quantidade}</p> 
                              <p>R$ {parseFloat(value.preco || 0).toFixed(2)}</p>
                            
                            </div>             
                          ))}               
                        </div>                      
                      </div>
                    }

                    {confirmModal ?
                    <ConfirmModal
                      isOpen={functionModal}                    
                      isClose={() => closeModal()}
                      contentLabel="Modal de Edição de Produto"                      
                      text={textModal}
                      link={link}
                    />
                    : ''}

                    {msgModal ?
                    <MsgModal
                      isClose={() => closeModal('msg')}                
                      contentLabel="Modal de Edição de Produto"                            
                      text={textModal}                    
                    />
                    : ''}
                  </div> 
                : 
                  <div className="menuContainer">
                    <div className="menuTop">
                      <span></span> 
                      <button onClick={() => fecharMenu()}>
                        <FontAwesomeIcon className="closeButtonMenu" icon={faXmark} />
                      </button>                     
                      
                    </div>
                    {!mostrarObservacao?   
                    <div className="menuItems">
                      {/* <button onClick={() => mostrarMesas('disponiveis', value.idGrupoPedido)}>Juntar Mesas</button> */}
                      <button onClick={() => mostrarMesas('ocupadas', value.idGrupoPedido)}>Ver Mesas</button>
                      <button onClick={() => adicionarObservacao(value.idGrupoPedido)}>Observação</button>
                    </div>
                    : 
                    <div className="divMostrarObservacao">
                    <textarea
                      className="textareaObservacao"
                      value={observacao}
                      onChange={(e) => setObservacao(e.target.value)}
                    />

                      <button 
                        onClick={() => salvarObservacao(observacao, idGrupoPedido)} 
                        className="buttonObservacao"
                      >
                        Salvar
                      </button>
                    </div>
                    }
                  </div> 
                }   
              </div>
            ))}
          </div>  
          :           
          <div className="divContainerMesa">   
            {
              Array.isArray(table) && table.length > 0 ? (
                table?.map((value) => (
                  <div key={value.idMesa}>
                    <button
                      onClick={() => unirMesa(value.idMesa, value.idGrupoPedido)}
                      className={`hover:bg-green-700 butonMesa ${value.idGrupoPedido > 0 ? 'mesaOcupada' : ''}`}
                    >
                      {value.nomeMesa}
                    </button>
                  </div>
                ))
              ) : null
            }                                                         
            <button onClick={() => setMesasOpen(null)} className="butonMesa bg-red-500 hover:bg-red-700 text-white font-bold">Voltar</button>                                       
          </div>}                                   
          {!removeLoading && <Loading />}  
        </div>        
      </main>
    </>
  );
}
